import React from 'react'

const IconStar = ({ style = {}, ...props }) => {
  return (
    <svg
      width="30"
      height="29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.392 1.377l.001-.004-3.961 8.029-.486.07-8.364 1.215a.68.68 0 0 0-.38 1.157l6.406 6.248-.083.483-1.434 8.336a.68.68 0 0 0 .982.72L15 23.414l.438.234 7.485 3.98a.68.68 0 0 0 .986-.717l-1.517-8.82.351-.342 6.053-5.904a.68.68 0 0 0-.377-1.158l-8.85-1.285-.218-.44-3.743-7.585a.68.68 0 0 0-1.216 0z"
        fill="#77CA34"
        fillOpacity=".07"
        stroke="#77CA34"
        strokeWidth="2"
      />
    </svg>
  )
}

export default IconStar
